var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcCloseCircle20X20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2A2A",
  fillRule: "evenodd",
  d: "M7 0a7 7 0 1 1 0 14A7 7 0 0 1 7 0m0 .875A6.13 6.13 0 0 0 .875 7 6.13 6.13 0 0 0 7 13.125 6.13 6.13 0 0 0 13.125 7 6.13 6.13 0 0 0 7 .875m0 4.832-1.94-1.94a.914.914 0 1 0-1.292 1.294L5.708 7l-1.94 1.94a.914.914 0 1 0 1.293 1.292L7 8.292l1.94 1.94a.914.914 0 1 0 1.292-1.293L8.292 7l1.94-1.94A.914.914 0 1 0 8.94 3.769z",
  clipRule: "evenodd"
})));
export default SvgIcCloseCircle20X20;